import React, { useEffect, useState } from "react";
import api from "@/api";
import { PageTitle, GlassCard, EmptyState } from "@/components/ui-kit";
import InspireBanner from "@/components/InspireBanner";
import { BarChart3, Scale } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";

const criteria = [
  { key: "hours", label: "إجمالي الساعات" },
  { key: "volunteers", label: "عدد المتطوعين" },
  { key: "opportunities", label: "عدد الفرص" },
];

export default function Statistics() {
  const [schools, setSchools] = useState([]);
  const [sort, setSort] = useState("hours");
  const [selected, setSelected] = useState([]);
  const [compareData, setCompareData] = useState([]);

  useEffect(() => { api.get("/schools").then((r) => setSchools(r.data)).catch(() => {}); }, []);

  const ranked = [...schools].sort((a, b) => (b.stats[sort] || 0) - (a.stats[sort] || 0));

  const toggle = (id) => setSelected((p) => p.includes(id) ? p.filter((x) => x !== id) : [...p, id]);

  useEffect(() => {
    if (selected.length < 2) { setCompareData([]); return; }
    api.get(`/stats/compare?school_ids=${selected.join(",")}`).then((r) => {
      setCompareData(r.data.map((s) => ({ name: s.name, الساعات: s.stats.hours, المتطوعون: s.stats.volunteers, الفرص: s.stats.opportunities })));
    }).catch(() => {});
  }, [selected]);

  return (
    <div>
      <InspireBanner />

      <PageTitle title="الإحصاءات والمقارنات" subtitle="ترتيب المدارس ومقارنة الأداء" icon={BarChart3}
        actions={<select value={sort} onChange={(e) => setSort(e.target.value)} className="px-3 py-2 rounded-xl bg-amber-50 border border-amber-400/30 text-stone-800 text-sm">{criteria.map((c) => <option key={c.key} value={c.key}>ترتيب حسب {c.label}</option>)}</select>}
      />

      {!schools.length ? <EmptyState text="لا توجد مدارس للمقارنة" icon={BarChart3} /> : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <GlassCard>
            <h3 className="font-head font-bold text-lg text-stone-800 mb-4">ترتيب المدارس</h3>
            <div className="space-y-2">
              {ranked.map((s, i) => (
                <label key={s.id} className="flex items-center gap-3 py-2 px-3 rounded-xl hover:bg-amber-100/70 transition cursor-pointer">
                  <input type="checkbox" checked={selected.includes(s.id)} onChange={() => toggle(s.id)} className="accent-amber-500 w-4 h-4" data-testid={`compare-${s.id}`} />
                  <span className="w-6 h-6 rounded-full bg-amber-500/15 text-amber-600 flex items-center justify-center text-xs font-bold">{i + 1}</span>
                  <span className="flex-1 text-sm text-stone-800 truncate">{s.name}</span>
                  <span className="text-sm font-bold text-amber-600">{s.stats[sort]}</span>
                </label>
              ))}
            </div>
          </GlassCard>

          <GlassCard>
            <div className="flex items-center gap-2 mb-4"><Scale className="text-amber-600" size={20} /><h3 className="font-head font-bold text-lg text-stone-800">مقارنة المدارس المختارة</h3></div>
            {compareData.length < 2 ? (
              <div className="py-16 text-center text-stone-500 text-sm">اختر مدرستين أو أكثر من القائمة للمقارنة</div>
            ) : (
              <ResponsiveContainer width="100%" height={340}>
                <BarChart data={compareData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(180,120,20,0.18)" />
                  <XAxis dataKey="name" stroke="rgba(68,64,60,0.75)" fontSize={11} />
                  <YAxis stroke="rgba(68,64,60,0.75)" fontSize={11} />
                  <Tooltip cursor={{ fill: "rgba(180,120,20,0.07)" }} contentStyle={{ background: "#241710", border: "1px solid rgba(212,175,55,0.3)", borderRadius: 12, color: "#FDF8F0" }} />
                  <Legend wrapperStyle={{ fontSize: 12 }} />
                  <Bar dataKey="الساعات" fill="#D4AF37" radius={[4, 4, 0, 0]} />
                  <Bar dataKey="المتطوعون" fill="#B45309" radius={[4, 4, 0, 0]} />
                  <Bar dataKey="الفرص" fill="#F59E0B" radius={[4, 4, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            )}
          </GlassCard>
        </div>
      )}
    </div>
  );
}
